import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-220f0cf6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "navigation-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BasicNavigationControl = _resolveComponent("BasicNavigationControl")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BasicNavigationControl, {
        id: "navigation-control",
        "previous-button-text": _ctx.previousButtonText,
        "next-button-text": _ctx.nextButtonText,
        "use-submit-icon": _ctx.useSubmitIcon
      }, null, 8, ["previous-button-text", "next-button-text", "use-submit-icon"])
    ])
  ]))
}